import store from '@/store'
import i18n from '../../lang'
import { router } from '@/router'
import { mapActions } from 'vuex'
import { unavailabilityDateList, createNewUnavailabilityDate, deleteUnavailabilityDate, unavailabilityDateCount, updateUnavailabilityDate, unavailabilityDateScheduled } from '@/backend/unavailabilityDates'

const SET_UNAVAILABILITY_DATE_LIST = 'SET_UNAVAILABILITY_DATE_LIST';
const SET_UNAVAILABILITY_DATE_LIST_SCOPED = 'SET_UNAVAILABILITY_DATE_LIST_SCOPED';
const UPDATE_CREATED_UNAVAILABILITY_DATE_TO_LIST = 'UPDATE_CREATED_UNAVAILABILITY_DATE_TO_LIST';
const REMOVE_UNAVAILABILITY_DATE_IN_LIST = 'REMOVE_UNAVAILABILITY_DATE_IN_LIST';
const SET_UNAVAILABILITY_DATE = 'SET_UNAVAILABILITY_DATE';
const UPDATE_UNAVAILABILITY_DATE_TO_LIST  = 'UPDATE_UNAVAILABILITY_DATE_TO_LIST ';
const UPDATE_UNAVAILABILITY_DATE_SCHEDULED = 'UPDATE_UNAVAILABILITY_DATE_SCHEDULED';

const state = {
  unavailabilityDateList: null,
  unavailabilityDateListScoped: null,
  unavailabilityDateCountPassed: 0,
  unavailabilityDateCountFuture: 0,
  unavailabilityDate: null,
  unavailabilityDateScheduled: {},
}

export const mutations = {
  [SET_UNAVAILABILITY_DATE_LIST] (state, unavailabilityDateList) {
    state.unavailabilityDateList = unavailabilityDateList
  },
  [SET_UNAVAILABILITY_DATE_LIST_SCOPED] (state, unavailabilityDateList) {
    state.unavailabilityDateListScoped = unavailabilityDateList
  },
  [UPDATE_CREATED_UNAVAILABILITY_DATE_TO_LIST] (state, unavailabilityDate) {
    state.unavailabilityDateList.push(unavailabilityDate)
  },
  [UPDATE_UNAVAILABILITY_DATE_TO_LIST] (state, unavailabilityDate) {
    let tempUnavailabilityDateList = [...state.unavailabilityDateList]
    let unavailabilityDateIndex = tempUnavailabilityDateList.findIndex((obj => obj.id == unavailabilityDate.id));
    tempUnavailabilityDateList[unavailabilityDateIndex] = unavailabilityDate
    state.unavailabilityDateList = [...tempUnavailabilityDateList]
  },
  [REMOVE_UNAVAILABILITY_DATE_IN_LIST] (state, removedID) {
    state.unavailabilityDateList = state.unavailabilityDateList.filter(date => date['id'] !== removedID)
  },
  [SET_UNAVAILABILITY_DATE] (state, unavailabilityDate) {
    state.unavailabilityDate = unavailabilityDate
  },
  [UPDATE_UNAVAILABILITY_DATE_SCHEDULED] (state, unavailabilityDateScheduled) {
    state.unavailabilityDateScheduled = unavailabilityDateScheduled
  },
};

export const actions = {
  loadList({ commit }, userId) {
    return unavailabilityDateList(userId)
    .then((response) => {
      let unavailabilityDateList = response.data
      commit(SET_UNAVAILABILITY_DATE_LIST, unavailabilityDateList)
    })
    .catch((error) => {
      store.dispatch('message/enable', { type: 'danger', content: error.response.data.error })
    })
  },

  loadListWithParams({ commit }, { userId, params }) {
    return unavailabilityDateList(userId, params)
    .then((response) => {
      let unavailabilityDateList = response.data
      commit(SET_UNAVAILABILITY_DATE_LIST_SCOPED, unavailabilityDateList)
    })
    .catch((error) => {
      store.dispatch('message/enable', { type: 'danger', content: error.response.data.error })
    })
  },

  loadUnavailabilityDateCount({ commit }, { userId, params }) {
    return unavailabilityDateCount(userId, params)
    .then((response) => {
      return (response.data)
    })
    .catch((error) => {
      store.dispatch('message/enable', { type: 'danger', content: error.response.data.error })
    })
  },

  loadUnavailabilityDateScheduled({ commit }, params) {
    return unavailabilityDateScheduled(Object.assign({}, params, { timezone: moment.tz.guess()}))
      .then((response) => {
        commit(UPDATE_UNAVAILABILITY_DATE_SCHEDULED, response.data.data)
      })
      .catch(() => {
        commit(UPDATE_UNAVAILABILITY_DATE_SCHEDULED, {})
      })
  },

  create({ commit, dispatch }, params) {
    return createNewUnavailabilityDate(params)
    .then((response) => {
      commit(UPDATE_CREATED_UNAVAILABILITY_DATE_TO_LIST, response.data)
    })
    .catch(error => {
      return Promise.reject(error.response.data.error)
    })
  },

  update({ commit, dispatch }, params) {
    return updateUnavailabilityDate(params)
    .then((response) => {
      commit(UPDATE_UNAVAILABILITY_DATE_TO_LIST, response.data)
    })
    .catch(error => {
      return Promise.reject(error.response.data.error)
    })
  },

  delete({ commit, dispatch }, unavailabilityDateID) {
    return deleteUnavailabilityDate(unavailabilityDateID)
      .then((response) => {
        commit(REMOVE_UNAVAILABILITY_DATE_IN_LIST, unavailabilityDateID)
      })
      .catch((error) => {
        dispatch('message/enable', { type: 'danger', content: error.response.data.error }, { root: true })
      })
  }
};

export const getters = {
  unavailabilityDateList: state => state.unavailabilityDateList,
  unavailabilityDateListScoped: state => state.unavailabilityDateListScoped,
  unavailabilityDateScheduled: state => state.unavailabilityDateScheduled,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/unavailabilityDates.js